import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
    }),

    dayStart() {
      return dayjs(this.date).tz(this.choosenTimezone).format('LL');
    },

    date() {
      return dayjs.tz(this.selectedSlot ? this.selectedSlot.start_date : this.lesson.slot.start_date, 'UTC');
    },

    now() {
      return dayjs.tz().format();
    },

    hourStart() {
      return dayjs(this.date).tz(this.choosenTimezone).format('HH:mm');
    },

    hourEnd() {
      return dayjs(this.dateEnd).tz(this.choosenTimezone).format('HH:mm');
    },

    dateEnd() {
      return dayjs.tz(this.selectedSlot ? this.selectedSlot.end_date : this.lesson.slot.end_date, 'UTC');
    },
    immediateStart() {
      return process.env.VUE_APP_IMMEDIATE_START === 'true';
    },
  },

  methods: {
    showStartButton(lesson) {
      if (this.immediateStart) return true;

      if (lesson && !lesson.ended
        && this.date.subtract(15, 'm').tz(this.choosenTimezone).format() <= this.now) {
        return true;
      }
      return false;
    },
  },
};
